/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Bookable_Members_HintInputs */

const en_admin_resource_form_bookable_members_hint = /** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your members can book this resource`)
};

const de_admin_resource_form_bookable_members_hint = /** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Mitglieder können diese Ressource buchen`)
};

const es_admin_resource_form_bookable_members_hint = /** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus miembros pueden reservar este recurso`)
};

const fr_admin_resource_form_bookable_members_hint = /** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos membres pourront réserver cette ressource`)
};

const nl_admin_resource_form_bookable_members_hint = /** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je leden kunnen deze voorziening reserveren`)
};

/** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */
const it_admin_resource_form_bookable_members_hint = en_admin_resource_form_bookable_members_hint;

/** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_bookable_members_hint = en_admin_resource_form_bookable_members_hint;

/** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */
const pl_admin_resource_form_bookable_members_hint = en_admin_resource_form_bookable_members_hint;

/** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */
const hu_admin_resource_form_bookable_members_hint = en_admin_resource_form_bookable_members_hint;

/** @type {(inputs: Admin_Resource_Form_Bookable_Members_HintInputs) => LocalizedString} */
const ro_admin_resource_form_bookable_members_hint = en_admin_resource_form_bookable_members_hint;

/**
* | output |
* | --- |
* | "Your members can book this resource" |
*
* @param {Admin_Resource_Form_Bookable_Members_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_bookable_members_hint = /** @type {((inputs?: Admin_Resource_Form_Bookable_Members_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Bookable_Members_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "de") return de_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "es") return es_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "it") return it_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_bookable_members_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_bookable_members_hint(inputs)
	return ro_admin_resource_form_bookable_members_hint(inputs)
});
export { admin_resource_form_bookable_members_hint as "admin.resource_form.bookable_members_hint" }